import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import StockSummaryServices from "../../../Services/QRCodeServices/StockSummaryServices/StockSummaryServices";
import toast from "react-hot-toast";

const StockItemAdjustment = ({ isOpen, toggle, dataS }) => {
  console.log("🚀 ~ StockItemAdjustment ~ dataS:", dataS);
  const formik = useFormik({
    enableReinitialize: true, // important when dataS changes

    initialValues: {
      productId: dataS,
      addedQuantity: 0,
      removedQuantity: 0,
      type: 1,
      remarks: "",
    },
    validationSchema: Yup.object({
      addedQuantity: Yup.number().min(0, "Must be >= 0"),
      removedQuantity: Yup.number().min(0, "Must be >= 0"),
      type: Yup.number().oneOf([1, 2], "Invalid type"),
      remarks: Yup.string().required("Remarks required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await StockSummaryServices.menuItemAdjust(values); // replace with your actual endpoint
        console.log("Success:", response.data);
        resetForm();
        toggle();
        toast.success(response);
      } catch (error) {
        console.error("Submission error:", error);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Stock Adjustment</ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          {/* <FormGroup>
            <Label for="productId">Product ID</Label>
            <Input
              id="productId"
              name="productId"
              type="number"
              value={formik.values.productId}
              onChange={formik.handleChange}
              invalid={formik.touched.productId && !!formik.errors.productId}
            />
          </FormGroup> */}

          <FormGroup>
            <Label for="addedQuantity">Added Quantity</Label>
            <Input
              id="addedQuantity"
              name="addedQuantity"
              type="number"
              value={formik.values.addedQuantity}
              onChange={formik.handleChange}
              invalid={
                formik.touched.addedQuantity && !!formik.errors.addedQuantity
              }
            />
          </FormGroup>

          <FormGroup>
            <Label for="removedQuantity">Removed Quantity</Label>
            <Input
              id="removedQuantity"
              name="removedQuantity"
              type="number"
              value={formik.values.removedQuantity}
              onChange={formik.handleChange}
              invalid={
                formik.touched.removedQuantity &&
                !!formik.errors.removedQuantity
              }
            />
          </FormGroup>

          <FormGroup>
            <Label for="type">Type</Label>
            <Input
              id="type"
              name="type"
              type="select"
              value={formik.values.type}
              onChange={(e) =>
                formik.setFieldValue("type", parseInt(e.target.value))
              }
              invalid={formik.touched.type && !!formik.errors.type}
            >
              <option value={1}>Consumed</option>
              <option value={2}>Disposed</option>
              <option value={3}>Adjusted</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="remarks">Remarks</Label>
            <Input
              id="remarks"
              name="remarks"
              type="text"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              invalid={formik.touched.remarks && !!formik.errors.remarks}
            />
          </FormGroup>

          <ModalFooter>
            <Button color="primary" type="submit">
              Submit
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default StockItemAdjustment;
